<template>
  <!--<a class="jo-copy-btn" v-clipboard:copy="text" v-clipboard:success="onCopy" >引</a>-->
  <!--<img class="jo-copy-btn" v-clipboard:copy="text" v-clipboard:success="onCopy" :src="imgurl">-->
  <a class="jo-copy-btn jom-copy-image" v-clipboard:copy="text" v-clipboard:success="onCopy">
    <img :src="imgurl">
  </a>

</template>

<script>
  export default {
    data() {
      return {
        imgurl: require('../../assets/img/copy.png')
      }
    },
    props: [
      'text'
    ],
    methods: {
      onCopy: function () {
        this.$message({
          message: '引文信息已复制，您可以直接黏贴',
          type: 'success'
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .jom-copy-image {
    img {
      vertical-align: text-bottom;
      height: 14px;
      width: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/componentsMobile/common/clipboard.vue